import { render, staticRenderFns } from "./Vilkaviar.vue?vue&type=template&id=75736950"
import script from "./Vilkaviar.vue?vue&type=script&lang=js"
export * from "./Vilkaviar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports